import { getFramework, IFramework } from '@/framework';
import { getStageGridStore } from './models/stage-grid-state';

export class StageGridPlugin {
    private framework: IFramework;
    constructor(id: string) {
        this.framework = getFramework(id);
    }

    showGridLineOperate(showGridLineOperate: boolean) {
        getStageGridStore(this.framework.identity).setShowGridLineOperate(showGridLineOperate);
    }

    /** 重置模板相关网格设置并清理预设选择，保留业务配置的入口开关 */
    reset() {
        getStageGridStore(this.framework.identity).resetGridInfo();
    }
}
